export const isSuperAdmin = (role: string) => role === "super_admin";

export const isAdmin = (role: string) => ["super_admin", "admin"].includes(role);

// Canonical values for role filters and display; authorization remains server-enforced.
export const normalizeRole = (role: string) => role.trim().toLowerCase();
